var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoungeRetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FF8598",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M9 16L18 7 27 16",
    transform: "translate(-2295 -575) translate(2295 575)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA506B",
    d: "M8.766 15h18.468c1.01 0 1.86.751 1.985 1.752l1.5 12c.137 1.096-.64 2.096-1.736 2.233-.083.01-.166.015-.249.015H7.266c-1.105 0-2-.895-2-2 0-.083.005-.166.015-.248l1.5-12c.125-1 .976-1.752 1.985-1.752z",
    transform: "translate(-2295 -575) translate(2295 575) rotate(-180 18 23)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "M11.823 20.823c.246-.073.309-.045.354 0 .045.045.073.108.073.177h0v5c0 .069-.028.132-.073.177-.045.045-.108.073-.177.073-.069 0-.132-.028-.177-.073-.045-.045-.073-.108-.073-.177h0v-5c0-.069.028-.132.073-.177zM17.823 20.823c.246-.073.309-.045.354 0 .045.045.073.108.073.177h0v5c0 .069-.028.132-.073.177-.045.045-.108.073-.177.073-.069 0-.132-.028-.177-.073-.045-.045-.073-.108-.073-.177h0v-5c0-.069.028-.132.073-.177zM23.823 20.823c.246-.073.309-.045.354 0 .045.045.073.108.073.177h0v5c0 .069-.028.132-.073.177-.045.045-.108.073-.177.073-.069 0-.132-.028-.177-.073-.045-.045-.073-.108-.073-.177h0v-5c0-.069.028-.132.073-.177z",
    transform: "translate(-2295 -575) translate(2295 575)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA506B",
    d: "M5 14h26c.552 0 1 .448 1 1v3c0 .552-.448 1-1 1H5c-.552 0-1-.448-1-1v-3c0-.552.448-1 1-1z",
    transform: "translate(-2295 -575) translate(2295 575)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoungeRetail);
export default __webpack_public_path__ + "static/media/lounge-retail.dcb7ab13.svg";
export { ForwardRef as ReactComponent };